module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAH5JREFUKFOVjsEJgDAMRTOrCziAh2ziGu7iyYsgCAqi1B70a20brOnFPGho8/gpgUAMRcXE5GbkBQsj7F4pEwFoBcDd+eAiEWoBcY1JhFGIdb++hSYwha6EQdgesgmL5GQS5g9K6AI2dCWcH5Swor8xcipB1z/Bqj/YVMjjZhc7mJGqupzewQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/text-plain.png
// module id = kVI0
// module chunks = 1